import { ActiveRecord, sources } from '@mysidewalk/active-record';
import LayerReference from '../features/LayerReference.js';
import LayerRecord from '../features/LayerRecord.js';
/**
 * @memberof customer-metadata
 * @property {number} id
 * @property {string} friendlyName
 * @property {string} description
 * @property {string} systemName
 * @property {string} geometryType
 * @property {string} processedFileUri
 * @property {number} featureCount
 * @property {object} organization
 * @property {object} upload
 * @property {string} gceObjectName
 * @property {object} drawingConfiguration
 * @property {number} featureClass
 * @property {string} featureLabelField
 */
class UserLayer extends ActiveRecord {
    toLayerReference() {
        return new LayerReference({
            sourceId: this.id,
            type: LayerReference.SourceType.CUSTOMER,
        });
    }
    toLayerRecord() {
        return new LayerRecord({
            ref: this.toLayerReference(),
            label: this.friendlyName,
        });
    }
}
UserLayer.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default UserLayer;
